{
  "dateFormat": "dd/MM/yyyy",
  "accessType": {
    "days_one": "{{count}} dia",
    "days_zero": "{{count}} dias",
    "days_other": "{{count}} dias",
    "byDays": "Por dias",
    "until": "Até {{date}}",
    "untilDate": "Até uma data",
    "lifetime": "Vitalício"
  },
  "enrollmentStatus": {
    "active": "Ativo",
    "expired": "Expirado",
    "cancelled": "Cancelado",
    "pending": "Pendente",
    "paused": "Pausado"
  },
  "gateways": {
    "guru": {
      "hint": "Cole esta URL em Configurações → Webhooks no painel da Guru."
    },
    "xtreed": {
      "hint": "Na Xtreed, abra o produto → Eventos, crie um evento POST com esta URL, adicione o cabeçalho acima e marque order_paid, order_refunded, order_chargeback e subscription_expired. O ID externo é o ID da oferta (o código que aparece no link do checkout)."
    },
    "hotmart": {
      "hint": "Na Hotmart, vá em Ferramentas → Webhook, cadastre esta URL (já com o token) e marque Compra aprovada, Reembolso, Chargeback e Cancelamento de assinatura. O ID externo pode ser o ID do produto ou o código da oferta."
    }
  },
  "copyableField": {
    "copy": "Copiar",
    "copied": "Copiado"
  },
  "list": {
    "title": "Grupos de Acesso",
    "subtitle": "Controle quais cursos cada grupo de alunos pode acessar",
    "newGroup": "Novo Grupo",
    "searchPlaceholder": "Buscar grupos...",
    "columns": {
      "title": "Título",
      "members": "Membros",
      "access": "Acesso",
      "products": "Produtos",
      "integrations": "Integrações"
    },
    "inactive": "Inativo",
    "actions": {
      "edit": "Editar",
      "duplicate": "Duplicar",
      "delete": "Excluir"
    },
    "deleteConfirm": {
      "title": "Excluir grupo de acesso",
      "description": "Tem certeza que deseja excluir este grupo de acesso?",
      "confirm": "Excluir"
    },
    "toast": {
      "deleted": "Grupo excluído",
      "deleteError": "Erro ao excluir grupo",
      "duplicated": "Grupo duplicado",
      "duplicateError": "Erro ao duplicar grupo"
    },
    "empty": {
      "title": "Nenhum grupo encontrado",
      "searchHint": "Tente outra busca",
      "createHint": "Comece criando seu primeiro grupo de acesso",
      "create": "Criar Grupo"
    },
    "pagination": {
      "summary_one": "Página {{page}} de {{totalPages}} ({{count}} grupo)",
      "summary_zero": "Página {{page}} de {{totalPages}} ({{count}} grupos)",
      "summary_other": "Página {{page}} de {{totalPages}} ({{count}} grupos)",
      "previous": "Anterior",
      "next": "Próxima"
    }
  },
  "createDialog": {
    "title": "Criar grupo de acesso",
    "tabs": {
      "info": "Informações",
      "products": "Produtos",
      "integrations": "Integrações",
      "members": "Membros"
    },
    "sections": {
      "general": {
        "title": "Informações gerais",
        "description": "Informe os dados gerais do seu grupo de acesso. Essas informações são essenciais para identificação dentro da área do administrador."
      },
      "accessTime": {
        "title": "Tempo de acesso",
        "description": "Indica o tempo disponível que os membros terão para interagirem com os produtos cadastrados neste grupo de acesso."
      },
      "terms": {
        "title": "Termos de uso",
        "description": "Configure o documento de termos de uso que deseja aplicar para este grupo de acesso."
      }
    },
    "accessOptions": {
      "days": {
        "title": "Período cadastrado",
        "description": "O membro terá acesso aos produtos conforme o período cadastrado."
      },
      "lifetime": {
        "title": "Vitalício",
        "description": "O membro terá acesso vitalício aos produtos."
      },
      "date": {
        "title": "Expiração fixa",
        "description": "O membro terá acesso aos produtos até a data determinada."
      }
    },
    "fields": {
      "title": "Título do grupo *",
      "titlePlaceholder": "Ex: Pacote Completo",
      "description": "Descrição *",
      "descriptionPlaceholder": "Descreva o que está incluído neste grupo...",
      "duration": "Duração (dias) *",
      "durationPlaceholder": "Ex: 365",
      "expirationDate": "Data de expiração *",
      "termsTitle": "Título do termo de uso",
      "termsTitlePlaceholder": "Ex: Termo de uso Xtreed",
      "fileUploaded": "Arquivo enviado",
      "setTerms": "Definir termo de uso"
    },
    "validation": {
      "titleMin": "Título deve ter no mínimo 3 caracteres",
      "descriptionRequired": "Descrição é obrigatória",
      "descriptionMax": "Máximo de 255 caracteres",
      "durationRequired": "Informe a duração em dias",
      "expirationRequired": "Informe a data de expiração"
    },
    "locked": {
      "products": "Salve as informações para gerenciar os produtos do grupo.",
      "integrations": "Salve as informações para configurar as integrações.",
      "members": "Salve as informações para gerenciar os membros."
    },
    "toast": {
      "fileUploaded": "Arquivo enviado",
      "fileUploadError": "Erro ao enviar arquivo",
      "created": "Grupo de acesso criado",
      "createError": "Erro ao criar grupo"
    },
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "save": "Salvar"
  },
  "formDialog": {
    "titleEdit": "Editar Grupo de Acesso",
    "titleNew": "Novo Grupo de Acesso",
    "descriptionEdit": "Edite as informações do grupo de acesso",
    "descriptionNew": "Crie um novo grupo para organizar produtos e matrículas",
    "fields": {
      "title": "Título *",
      "titlePlaceholder": "Ex: Pacote Completo",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva o que está incluído neste grupo...",
      "accessType": "Tipo de Acesso",
      "accessTypePlaceholder": "Selecione o tipo de acesso",
      "lifetime": "Vitalício",
      "byDays": "Por dias",
      "untilDate": "Até uma data",
      "duration": "Duração (dias) *",
      "durationPlaceholder": "Ex: 365",
      "expirationDate": "Data de Expiração *",
      "status": "Status",
      "active": "Ativo",
      "inactive": "Inativo",
      "terms": "Termos de uso",
      "termsTitlePlaceholder": "Título do termo de uso",
      "currentFile": "Arquivo atual",
      "setTerms": "Definir termo de uso"
    },
    "validation": {
      "titleMin": "Título deve ter no mínimo 3 caracteres"
    },
    "toast": {
      "fileUploaded": "Arquivo enviado",
      "fileUploadError": "Erro ao enviar arquivo"
    },
    "saveError": "Erro ao salvar grupo",
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "saveChanges": "Salvar Alterações",
    "create": "Criar Grupo"
  },
  "integrationDialog": {
    "titleEdit": "Editar integração",
    "titleNew": "Nova integração",
    "description": "Conecte uma plataforma de pagamento a este grupo.",
    "fields": {
      "name": "Nome *",
      "namePlaceholder": "Ex: Checkout Pacote Completo — Guru",
      "gateway": "Plataforma",
      "select": "Selecione",
      "status": "Status",
      "active": "Ativo",
      "inactive": "Inativo",
      "externalId": "ID externo (gateway) *",
      "externalIdPlaceholder": "ID da oferta/produto na {{gateway}}",
      "externalIdHelp": "É por este ID que o webhook identifica o pagamento e matricula o aluno neste grupo.",
      "price": "Preço exibido aos alunos",
      "priceHelp": "Aparece no botão de compra do curso bloqueado. Deixe em branco para não mostrar preço.",
      "currency": "Moeda"
    },
    "webhookTitle": "Webhook da {{gateway}}",
    "validation": {
      "nameMin": "Nome deve ter no mínimo 2 caracteres",
      "externalIdRequired": "ID externo é obrigatório",
      "price": "Use um valor como 97 ou 97,90"
    },
    "toast": {
      "updated": "Integração atualizada",
      "created": "Integração criada",
      "saveError": "Erro ao salvar integração"
    },
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "saveChanges": "Salvar alterações",
    "create": "Criar integração",
    "secret": {
      "urlLabel": "URL do webhook",
      "headerLabel": "Nome do cabeçalho",
      "tokenLabel": "Valor do cabeçalho (token)",
      "headerHelp": "Gere o token desta escola e envie no cabeçalho do webhook. É ele que identifica a sua área de membros.",
      "queryHelp": "Gere o token desta escola. Ele entra na própria URL, porque a Hotmart não permite cabeçalhos personalizados.",
      "shownOnce": "Copie agora: o token só aparece uma vez. Gerar outro invalida o anterior.",
      "generate": "Gerar token",
      "regenerate": "Gerar novo token",
      "error": "Não foi possível gerar o token"
    }
  },
  "productsDialog": {
    "status": {
      "published": "Publicado",
      "archived": "Arquivado",
      "draft": "Rascunho"
    },
    "title": "Produtos do grupo",
    "description": "Selecione os produtos incluídos em “{{title}}”.",
    "searchPlaceholder": "Buscar produto...",
    "inGroup": "Produtos no grupo",
    "noResults": "Nenhum produto encontrado",
    "noneSelected": "Nenhum produto selecionado ainda",
    "available": "Disponíveis",
    "allInGroup": "Todos os produtos já estão no grupo",
    "pageOf": "Página {{page}} de {{total}}",
    "previous": "Anterior",
    "next": "Próxima",
    "pendingChanges": "{{added}} para adicionar · {{removed}} para remover",
    "selectedCount_one": "{{count}} produto no grupo",
    "selectedCount_zero": "{{count}} produtos no grupo",
    "selectedCount_other": "{{count}} produtos no grupo",
    "toast": {
      "updated": "Produtos atualizados",
      "saveError": "Erro ao salvar produtos"
    },
    "cancel": "Cancelar",
    "saving": "Salvando...",
    "save": "Salvar"
  },
  "productAssignment": {
    "description": "Adicione, remova e reordene os cursos desta seção",
    "inSection": "Na Seção",
    "courseCount_one": "{{count}} curso",
    "courseCount_zero": "{{count}} cursos",
    "courseCount_other": "{{count}} cursos",
    "emptyTitle": "Nenhum curso nesta seção",
    "emptyHint": "Adicione da lista ao lado",
    "available": "Disponíveis",
    "searchPlaceholder": "Buscar cursos...",
    "noResults": "Nenhum curso encontrado",
    "allInSection": "Todos os cursos já estão nesta seção",
    "close": "Fechar",
    "toast": {
      "added": "Produto adicionado à seção",
      "addError": "Erro ao adicionar produto",
      "removed": "Produto removido da seção",
      "removeError": "Erro ao remover produto",
      "reorderError": "Erro ao reordenar"
    }
  },
  "detail": {
    "active": "Ativo",
    "inactive": "Inativo",
    "back": "Voltar",
    "notFound": "Grupo de acesso não encontrado",
    "backToList": "Grupos de Acesso",
    "membersCount_one": "{{count}} membro",
    "membersCount_zero": "{{count}} membros",
    "membersCount_other": "{{count}} membros",
    "productsCount_one": "{{count}} produto",
    "productsCount_zero": "{{count}} produtos",
    "productsCount_other": "{{count}} produtos",
    "tabs": {
      "info": "Informações",
      "products": "Produtos ({{count}})",
      "integrations": "Integrações",
      "members": "Membros ({{count}})"
    },
    "deleteIntegrationConfirm": {
      "title": "Excluir integração",
      "description": "Tem certeza que deseja excluir esta integração?",
      "confirm": "Excluir"
    },
    "toast": {
      "integrationDeleted": "Integração removida",
      "integrationDeleteError": "Erro ao excluir integração"
    },
    "info": {
      "title": "Informações do grupo",
      "edit": "Editar",
      "fields": {
        "title": "Título",
        "status": "Status",
        "accessType": "Tipo de acesso",
        "products": "Produtos",
        "members": "Membros",
        "createdAt": "Criado em",
        "updatedAt": "Atualizado em",
        "description": "Descrição",
        "terms": "Termos de uso"
      },
      "noDescription": "Sem descrição",
      "termsDefault": "Termo de uso",
      "viewFile": "ver arquivo",
      "notDefined": "Não definido"
    },
    "products": {
      "title": "Produtos no grupo ({{count}})",
      "description": "Cursos e conteúdos liberados para os membros deste grupo.",
      "manage": "Gerenciar",
      "published": "Publicado",
      "draft": "Rascunho",
      "empty": "Nenhum produto neste grupo ainda",
      "add": "Adicionar produtos"
    },
    "integrations": {
      "title": "Integrações configuradas",
      "description": "Checkouts vinculados a este grupo, identificados pelo ID externo.",
      "new": "Nova integração",
      "noExternalId": "Sem ID externo",
      "edit": "Editar",
      "delete": "Excluir",
      "empty": "Nenhuma integração vinculada a este grupo ainda"
    },
    "members": {
      "title": "Membros ({{count}})",
      "description": "Alunos matriculados via compra ou manualmente.",
      "enroll": "Matricular",
      "searchPlaceholder": "Buscar por nome, email ou CPF...",
      "statusPlaceholder": "Status",
      "allStatuses": "Todos os status",
      "columns": {
        "member": "Membro",
        "progress": "Progresso",
        "joined": "Entrada",
        "expiration": "Expiração",
        "status": "Status"
      },
      "pagination": {
        "summary_one": "Página {{page}} de {{totalPages}} ({{count}} membro)",
        "summary_zero": "Página {{page}} de {{totalPages}} ({{count}} membros)",
        "summary_other": "Página {{page}} de {{totalPages}} ({{count}} membros)",
        "previous": "Anterior",
        "next": "Próxima"
      },
      "emptyFiltered": "Nenhum membro encontrado com esses filtros",
      "empty": "Nenhum membro matriculado ainda",
      "enrollUser": "Matricular usuário"
    }
  }
}
